import React from "react";
import { useTranslation } from "react-i18next";

export default function Helpins() {
  const { t } = useTranslation("help");

  return (
    <div className="instructions-page">
      <h3>{t("helpIns.title", "Instructions")}</h3>

      <div className="base-url">
        {t("helpIns.baseUrl", "BASE URL:")}{" "}
        <strong>
          {t("helpIns.baseUrlValue", "https://demo.whitehax.com/api/external")}
        </strong>
      </div>

      <ul>
        <li>{t("helpIns.installPython", "Install python")}</li>

        <li>
          {t("helpIns.openTerminalRoot", "Open terminal in root folder i.e.")}{" "}
          <strong>/py/</strong>

          <ul>
            <li>
              {t("helpIns.initVenv", "Initialize venv if needed")}{" "}
              {/*[might be different on windows]*/}
            </li>
          </ul>

          <div className="command">
            &gt;&gt; python3 -m venv .venv
          </div>

          <div className="command">
            &gt;&gt; source .venv/bin/activate
          </div>

          <ul>
            <li>{t("helpIns.installRequests", "Install requests")}</li>
          </ul>

          <div className="command">
            &gt;&gt; pip {t("helpIns.installRequests")}
          </div>
        </li>

        <li>
          {t(
            "helpIns.openTerminalDir",
            "Open terminal in directory in which file is present"
          )}
        </li>

        <li>{t("helpIns.setApiKey", "Set API Key at top of file")}</li>

        <li>
          {t("helpIns.setParams", "Set parameters in the file as needed")}
        </li>

        <li>{t("helpIns.runFile", "Run file")}</li>

        <div className="command">
          &gt;&gt; python3 &lt;filename&gt;
        </div>
      </ul>

      <section className="content-section">
        <div className="section-title">{t("helpIns.flowTitle", "Flow:")}</div>

        <ul>
          {(
            t("helpIns.flowSteps", {
              returnObjects: true,
              defaultValue: [
                "Make Endpoint",
                "Fetch Test Files",
                "Use Endpoint ID, Test Files info and Profile config to create Profile",
                "Use Profile ID to run test"
              ]
            }) || []
          ).map((step, idx) => (
            <li key={idx}>{step}</li>
          ))}
        </ul>
      </section>

      <section className="content-section notes-section">
        <div className="section-title">
          {t("helpIns.notesTitle", "Notes:")}
        </div>

        <ul>
          <li>
            {t(
              "helpIns.notes.0",
              "General: Change values at top of each file"
            )}
          </li>

          <li>
            {t(
              "helpIns.notes.1",
              "Create Endpoint with i/o scripts: Change values in input_script.py/output_script.py"
            )}
          </li>

          <li>
            {t(
              "helpIns.notes.2",
              "Profile Config params can be set in profile_config.json"
            )}
          </li>
        </ul>
      </section>

      <style>{`
        .instructions-page {
          width: 100%;
          min-height: 100vh;
          box-sizing: border-box;

          background: #1f1f1f;
          color: #f5f5f5;


          font-size: 16px;
          line-height: 1.45;

          padding: 0 28px 30px 28px;
        }

        .instructions-page h3 {
          margin: 0 0 20px 0;
          padding-top: 0;

          color: #ffffff;
          font-size: 17px;
          font-weight: 600;
        }

        .base-url {
          margin-bottom: 20px;
          color: #f2f2f2;
        }

        .base-url strong {
          color: #ffffff;
          font-weight: 700;
        }

        .instructions-page ul {
          margin-top: 8px;
          margin-bottom: 12px;
          padding-left: 54px;
        }

        .instructions-page li {
          padding-left: 2px;
          margin-bottom: 5px;
        }

        .instructions-page li::marker {
          color: #ffffff;
        }

        .instructions-page li > ul {
          margin-top: 6px;
          margin-bottom: 6px;
          padding-left: 29px;
        }

        .instructions-page li > ul li {
          margin-bottom: 3px;
        }

        .command {
          margin: 2px 0 2px 0;
          color: #ffffff;
          font-family: Arial, Helvetica, sans-serif;
          white-space: pre-wrap;
        }

        .content-section {
          margin-top: 62px;
        }

        .notes-section {
          margin-top: 20px;
        }

        .section-title {
          margin-bottom: 2px;
          color: #ffffff;
          font-size: 16px;
        }

        .content-section ul {
          margin-top: 2px;
          margin-bottom: 0;
          padding-left: 54px;
        }

        .content-section li {
          margin-bottom: 3px;
        }

        .notes-section li {
          margin-bottom: 3px;
        }

        .instructions-page strong {
          font-weight: 700;
          color: #ffffff;
        }
      `}</style>
    </div>
  );
}